// const API_BASE_URL = 'http://localhost:8080/api'
// const API_BASE_URL = 'https://web-production-59e72.up.railway.app/api' -- encien compte de taoufik

const API_BASE_URL = 'https://deploy3-production-285a.up.railway.app/api'

export default API_BASE_URL;




// test de deploy